import React from 'react';
import clsx from 'clsx';
import Button from 'components/UI/V3/Button/Button';
import styles from './ToggleTabs.module.scss';

export interface ToggleTabOption {
    id: string;
    label: React.ReactNode; // admite texto o nodo (iconos, etc.)
}

interface ToggleTabsProps {
    options: ToggleTabOption[];
    value: string;
    setValue: (id: string) => void;
    className?: string;
}

export const ToggleTabs: React.FC<ToggleTabsProps> = ({ options, value, setValue, className }) => {
    return (
        <div
            className={clsx(styles.root, className)}
            style={
                {
                    '--count': Math.max(1, options.length),
                    '--index': Math.max(
                        0,
                        options.findIndex(o => o.id === value)
                    )
                } as React.CSSProperties
            }
        >
            <div
                className={styles.slider}
                aria-hidden
            />
            {options.map(opt => {
                const active = opt.id === value;
                return (
                    <Button
                        key={opt.id}
                        size="small"
                        variant="outlined"
                        className={clsx(styles.tab, active && styles.active)}
                        onClick={() => setValue(opt.id)}
                        label={opt.label}
                    />
                );
            })}
        </div>
    );
};

export default ToggleTabs;
